import request from 'local_modules/request'
import { constants, modals } from 'helpers'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.adminLearnPage.setFetching(isFetching)

const fetchTrainers = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentTrainer + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminLearnPage.setTrainers(data))
    .catch((error) => console.log(error))
}

const setTrainers = (trainers) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.environmentTrainer + `/${tool}`, trainers)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}

const fetchTrainersParams = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentTrainersParams + `/${tool}`)
    .then(({ data }) => data[0])
    .then((data) => reducers.marketplace.adminLearnPage.setTrainersParams({
      id: data.id,
      price: data.price,
      from: data.minQuota,
      to: data.maxQuota,
      category: data.category,
    }))
    .catch((error) => console.log(error))
}

const setTrainersParams = ({ from, to, price }) => {
  const {
    marketplace: {
      adminLearnPage: { trainersParams },
      layersNavigation: { tool },
    },
  } = getState()

  if (!trainersParams.id) {
    console.log('No id passed')

    return request.post(constants.marketplace.environmentTrainersParams + `/${tool}`, [{
      "category" : {"name":"learning"},
      "minQuota" : 0,
      "maxQuota" : 10,
      "price" : 13.12
    }])
  }
  if (!trainersParams.category) {
    console.log('No category passed')

    return Promise.resolve()
  }

  return request.post(constants.marketplace.environmentTrainersParams + `/${tool}`, [{
    id: trainersParams.id,
    category: trainersParams.category,
    minQuota: from,
    maxQuota: to,
    price,
  }])
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}


export default {
  setFetching,
  setTrainers,
  fetchTrainers,
  fetchTrainersParams,
  setTrainersParams,
}
